import React from 'react';
import styled from 'styled-components';
import {Times} from '@styled-icons/fa-solid/Times';
import { DraggableAndResizablePopup } from '../../Modal/components/DraggablePopup';

const Wrapper = styled.div`
  z-index: 11;
  background: white;
  position: relative;
  overflow: visible;
  border: 1px solid #ccc;
  margin-top: 23px;
`;
const Image = styled.img.attrs({draggable: false})`
  width: 100%;
  height: auto;
`;

const CloseButton = styled(Times)`
  position: absolute;
  top: -23px;
  right: 0;
  width: 23px;
  height: 23px;
  text-align: center;
  background: red;
  color: white;
  cursor: pointer;
`;

const PeriodicTable = ({onCloseExhibit, template}) => (
  <DraggableAndResizablePopup>
    <Wrapper>
      <CloseButton onClick={onCloseExhibit} />
      <Image src={`${process.env.PUBLIC_URL}/assets/periodic/periodic_table.png`} />
    </Wrapper>
  </DraggableAndResizablePopup>
);

export default PeriodicTable;
